namespace TabAurous {

    @Serenity.Decorators.registerEditor()
    export class CommonSubCategoryLookup extends
        Serenity.LookupEditorBase<Serenity.LookupEditorOptions, OMS.SubCategoryDetailsRow> {

        public CategoryId: number;

        constructor(container: JQuery, opt: Serenity.LookupEditorOptions) {
            super(container, opt);
        }

        protected getLookupKey() {
            return OMS.SubCategoryDetailsRow.lookupKey;
        }

        protected getItems(lookup: Q.Lookup<any>) {
            var results = Q.getLookup(OMS.SubCategoryDetailsRow.lookupKey);
            
            let items = super.getItems(results);
            if (q.isNumber(this.CategoryId)) {

                let filters = {
                    CategoryId: [this.CategoryId, 0],
                    //ItemTypeId: [105]
                };
                
                items = q.Filter(items, filters)
            }              
            return items;
        }

    }

}
